import { Button, CircularProgress, Grid } from "@material-ui/core";
import * as React from "react";
import { useEffect, useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { ErrorModal } from "../../../../../components/modals/error-modal";
import MesfModal from "../../../../../components/modals/modal.mesf";
import { useEmailTopicsContext } from "../../context/EmailTopicsContext";
import {
	EmailTopicFormValues,
	INITIAL_VALUES,
} from "../../models/FormInitialValues";
import { upsertEmailTopic } from "../../repositories/EmailTopicsRepository";
import { EmailTopicFormFields } from "./EmailTopicFormFields";

type Props = {
	show: boolean;
	onHide: (shouldUpdate: boolean) => void;
};

// The delay arrives from the form as text because the field is empty until someone types a number.
const toDelay = (value: string) =>
	value === "" || value === null ? null : Number(value);

export const CreateEmailTopic = ({ show, onHide }: Props) => {
	const [isSubmitLoading, setIsSubmitLoading] = useState(false);
	const [error, setError] = useState("");
	const {
		state: { addresses },
	} = useEmailTopicsContext();

	const { control, handleSubmit, reset } = useForm<EmailTopicFormValues>({
		defaultValues: INITIAL_VALUES,
	});

	const onSubmit: SubmitHandler<EmailTopicFormValues> = async (data) => {
		setIsSubmitLoading(true);
		try {
			await upsertEmailTopic({
				EmailTopicId: null,
				EmailTopicName: data.EmailTopicName,
				Description: data.Description || null,
				DelayTimeMinutes: toDelay(data.DelayTimeMinutes),
				IsActive: data.IsActive,
				AddressIdsTO: data.AddressIdsTO,
				AddressIdsCC: data.AddressIdsCC,
				AddressIdsBCC: data.AddressIdsBCC,
			});
			onHide(true);
		} catch (e: any) {
			setError(e?.message || "Error saving email topic");
		} finally {
			setIsSubmitLoading(false);
		}
	};

	useEffect(() => {
		if (show) reset(INITIAL_VALUES);
	}, [show]);

	return (
		<>
			<ErrorModal error={error} onHide={() => setError("")} />
			<MesfModal
				title="NEW EMAIL TOPIC"
				open={show}
				handleClose={() => onHide(false)}
				id="create-email-topic-modal"
				maxWidth="md"
			>
				<form onSubmit={handleSubmit(onSubmit)}>
					<MesfModal.Content style={{ padding: "15px 30px 0" }}>
						<EmailTopicFormFields control={control} addresses={addresses} />
					</MesfModal.Content>
					<MesfModal.Actions>
						<Grid
							container
							spacing={2}
							justifyContent="flex-end"
							style={{ padding: "1rem" }}
						>
							<Grid item md={3} xs={12}>
								<Button
									fullWidth
									variant="contained"
									onClick={() => onHide(false)}
									disabled={isSubmitLoading}
								>
									CANCEL
								</Button>
							</Grid>
							<Grid item md={3} xs={12}>
								<Button
									fullWidth
									type="submit"
									variant="contained"
									color="primary"
									disabled={isSubmitLoading}
								>
									{isSubmitLoading ? <CircularProgress size={24} /> : "CREATE"}
								</Button>
							</Grid>
						</Grid>
					</MesfModal.Actions>
				</form>
			</MesfModal>
		</>
	);
};
